<template>
  <div style="width: 100%">
    <headers2 :title="titles"></headers2>

    <div class="contentBox">

      <div class="content">
        <div class="mzsm">
          <el-button type="primary" size="small" @click="toMzsm">免责声明</el-button>
        </div>

        <el-card class="box-card"  >

          <el-link :underline="false" type="primary" @click="toSee">{{names}}.pdf</el-link>

        </el-card>

      </div>
    </div>


    <el-dialog
      title="免责声明"
      :visible.sync="dialogVisible"
      :show-close="false"
      :center="true"
      width="50%">
      <div class="title">使用说明</div>
      <div class="text">本栏目为社会公众提供地理标志产品信息检索，本系统的数据信息并非实时更新，有一定滞后性，仅供参考，不具有法律效力，以国家知识产权局官方公告信息为准。</div>
      <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dialogVisible = false">我接受</el-button>
    </span>
    </el-dialog>


    <footers></footers>
  </div>
</template>

<script>
import headers2 from "../../../comm/components/headers2.vue";
import pos_top1 from  "../../../comm/components/pos_title_top.vue"
import footers from '@comm/components/footers.vue'
import {moreList, searchDetail, searchInit} from "../../api/query";
export default {
  name: "details",
  components:{
    headers2,pos_top1,footers
  },
  data(){
    return{
      isMore:false,
      names:'',
      total:0,
      formInline:{
        name:'',
        type:'',
        limit:10,
        page:'1',
      },
      moreData:[],
      titles:'地理标志产品检索',
      dialogVisible:false,
      activeName:'first',
      policyAnswersData:{},
      id:'',
      baseUrl:'',

    }
  },

  created() {
    this.id = this.$route.query.id || ''
    this.names = this.$route.query.name || ''

  },

  mounted() {
    this.getDetail()
  },


  methods:{



    getDetail(){
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      searchDetail({id:this.id}).then(res=>{
        if(res.errorCode == 200){
          loading.close()

          this.baseUrl = res.data

        }

      })
    },

    //
    toSee(){
      if (this.baseUrl){
        window.open(this.baseUrl,'_blank')
      }



    },

    //初始化数据
    getData(){
      const loading = this.$loading({
        lock: true,
        text: '拼命加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      searchInit().then(res=>{
        if (res.errorCode  == 200){
          loading.close()
          this.policyAnswersData = res.data
        }

      })
    },
    //免责声明
    toMzsm(){
      this.dialogVisible = true
    },


  }
}
</script>


<style scoped lang="less">

.contentBox{
  width: 100%;
  min-height: 100vh-40rem;
  display: flex;
  justify-content: center;


  .content{
    display: block;
    width: 75rem;
    .mzsm{
      text-align: right;
      margin-bottom: 0.875rem;
    }
  }

}
.title{
  font-weight: bold;
  font-size: 1.25rem;
}
.text{
  margin-top: 1.25rem;
  text-indent: 2em;
  line-height: 2rem;
  font-size: 1rem;
}
.box-card{
  min-height: 20rem;
}
</style>



// WEBPACK FOOTER //
// src/landmark-user/views/dbQuery/details.vue